// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-landing-page -> ctl-management-landing-page -> heather-lodge-apartments
// Generated: 2026-10-05T21:08:16.504Z
// Counts: 1 design, 11 content, 2 slot group, 2 collection binding, 3 section, 0 style

export const designOverrides = {
  "design.SpecialOffers.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_4"
  }
};

export const contentOverrides = {
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "hero.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "multihub-lead-capture.lead_source": {
    "overrideType": "VALUE",
    "customValue": "LANDING_PAGE",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/company/5767906449162446/019de45f-df6f-7750-bec5-e26263c2e1b3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "fees.pet_policy": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "privacy-consent.opt_out_scope": {
    "overrideType": "VALUE",
    "customValue": "all",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "neighborhoodmap.description": {
    "overrideType": "VALUE",
    "customValue": "Nestled just 10 miles southeast of Portland, Happy Valley is the perfect suburb for commuters. With a central location and park-like atmosphere, renters in Happy Valley couldn’t be much happier! Scouters Mountain Nature Park, Hidden Falls Nature Park, Happy Valley Park, and Mount Talbert Nature Park are just a few of the scenic green spaces available to residents. Hiking trails, sweeping views, and summer concerts are commonplace in this active community. Apartments and houses in the area range from affordable to upscale, so there’s something for every renter in Happy Valley. Although this suburb is mainly residential, residents spend most of their free time exploring the great outdoors or traveling to nearby Portland for dining, shopping, and entertainment options. \t\t\t\t\t \t\t\t\t\t \t\t\t\t\t\tLearn more about living in Happy Valley",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "header.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_medium=ppc&utm_source=google&utm_campaign=landing-page"
      }
    }
  },
  "hero.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodmap.pois": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "privacy-consent",
      "blockId": "privacy-consent",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
